import React from 'react';
import { Helmet } from 'react-helmet';
import config from 'sharedConfig';

export default function CategoryHeadTags(props) {
  const title = props.title && !props.searchQuery ?
    props.title :
    'Saucey: Alcohol Delivery in 30 minutes';
  const description = props.description && !props.searchQuery ?
    props.description :
    'Alcohol delivery in 30 minutes. Shop 10,000+ products - Great prices! Order craft beer, wine and spirits online or download the mobile app for iOS or Android.'
  const url = props.searchQuery ?
    [config.site.url, 'search', props.searchQuery].join('/') :
    [config.site.url, props.slug].join('/');

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
    </Helmet>
  );
}



// WEBPACK FOOTER //
// ./shared/components/category/head.js